import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acb3bc0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item_div" }

import { ref,onMounted,onBeforeMount } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AddElementModal',
  props: {
  width: {
    type: Number,
    default: 320
  },
  top: {
    type: Number,
    default: 80
  },
},
  setup(__props) {

const props = __props;


const elRight:any = ref(80)
const elTop:any = ref(80)
const startclientX:any = ref()//元素初始位置
const startclientY: any = ref()
onBeforeMount(() => {
  elTop.value = props.top
})
const dragstart = (e: any) => {
  startclientX.value = e.clientX; // 记录拖拽元素初始位置
  startclientY.value = e.clientY;
}

const dragend = (e:any) => {
      let x = e.clientX - startclientX.value; // 计算偏移量
      let y = e.clientY - startclientY.value;
      elRight.value -= x; // 实现拖拽元素随偏移量移动
      elTop.value += y;

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "add-element-handler-item",
    draggable: "true",
    onDragstart: _cache[0] || (_cache[0] = ($event: any) => (dragstart($event))),
    onDragend: _cache[1] || (_cache[1] = ($event: any) => (dragend($event))),
    style: _normalizeStyle(`right:${elRight.value}px;top:${elTop.value}px;width:${__props.width}px`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ], 36))
}
}

})